import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Lock, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function PurchaseSection() {
  const combos = [{
    title: 'Guía para Hacer Esquejes',
    subtitle: 'Todo lo que necesitas para empezar',
    price: '$13.99',
    currency: 'USD',
    image: 'https://cdn.magicpatterns.com/uploads/veKGvWWMpGDJWAzPky54mN/ChatGPT_Image_19_ene_2026,_03_20_12.png',
    features: ['Guía Completa para Hacer Esquejes', 'Bonus 1: Sustratos Caseros', 'Bonus 2: Guía Rápida de Plantas Populares', 'Bonus 3: Hormonas de Enraizamiento', 'Bonus 4: Mini Invernadero Casero', 'Bonus 5: Calendario del Esqueje', 'Entrega inmediata en PDF', 'Acceso de por vida'],
    cta: 'Empezar ahora',
    checkoutUrl: 'https://pay.hotmart.com/V104246835H',
    highlight: false
  }, {
    title: 'Propagación Completa',
    subtitle: 'Ideal si quieres profundizar',
    price: '$19.90',
    currency: 'USD',
    image: 'https://cdn.magicpatterns.com/uploads/ffJZeiPw7ZJZT5U4bDmMkG/Gula_practica_para_plantAs_sanas,_FUERTES_y_sin_venenos..png',
    features: ['Todo lo incluido en el Combo 1', 'Manual: Fertilizantes y Plaguicidas Naturales Caseros', 'Entrega inmediata en PDF', 'Acceso de por vida'],
    cta: 'Obtener Combo Completo',
    checkoutUrl: 'https://pay.hotmart.com/L104247048Q',
    highlight: true,
    badge: 'RECOMENDADO'
  }, {
    title: 'Producción Comercial',
    subtitle: 'Empieza a vender tus propias plantas',
    price: '$26.90',
    currency: 'USD',
    image: 'https://cdn.magicpatterns.com/uploads/adiwPphaDGshDTcc65KzCi/Guia_practica_para_plantas_sanas_fuertes_y_sin_venenos.png',
    features: ['Todo lo incluido en el Combo 1', 'Todo lo incluido en el Combo 2', 'Manual: Organización y Producción a Pequeña Escala', 'Entrega inmediata en PDF', 'Acceso de por vida'],
    cta: 'Quiero Vender Plantas',
    checkoutUrl: 'https://pay.hotmart.com/T104247116J',
    highlight: false
  }];
  return <section className="py-20 bg-[#fafaf9]" data-id="element-88">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        {/* Header & Social Proof */}
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-91">
            Elige el combo que mejor se adapte a tu objetivo
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-92">
            Todos los materiales son digitales y de acceso inmediato
          </p>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 inline-block text-left max-w-2xl" data-id="element-93">
            <div className="flex items-center gap-2 mb-2 text-[#4a7c2c] font-semibold" data-id="element-94">
              <Star className="w-5 h-5 fill-current" data-id="element-95" />
              +1.578 personas ya están multiplicando sus plantas con éxito
            </div>
            <p className="text-gray-700 italic mb-2" data-id="element-96">
              "Antes perdía 8 de cada 10 esquejes. Ahora casi todos enraízan. La
              diferencia es tener un método claro."
            </p>
            <p className="text-sm font-bold text-gray-900" data-id="element-97">— Carla, Bogotá</p>
          </div>
        </div>

        {/* Combos Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto mb-16 items-start" data-id="element-98">
          {combos.map((combo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`relative bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col ${combo.highlight ? 'ring-4 ring-[#4a7c2c] scale-105 z-10' : 'border border-gray-100'}`} data-id="element-99">
              {combo.highlight && <div className="bg-[#4a7c2c] text-white text-center py-2 font-bold text-sm tracking-wide" data-id="element-100">
                  {combo.badge}
                </div>}

              <div className="p-6 flex-1 flex flex-col" data-id="element-101">
                <div className="aspect-[4/3] mb-6 bg-gray-50 rounded-lg overflow-hidden flex items-center justify-center p-4" data-id="element-102">
                  <img src={combo.image} alt={combo.title} className="h-full w-auto object-contain hover:scale-105 transition-transform duration-300" data-id="element-103" />
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-104">
                  {combo.title}
                </h3>
                <p className="text-sm text-gray-500 mb-4 h-10" data-id="element-105">
                  {combo.subtitle}
                </p>

                <div className="text-3xl font-bold text-[#4a7c2c] mb-6" data-id="element-106">
                  {combo.price}{' '}
                  <span className="text-sm font-normal text-gray-500" data-id="element-107">
                    {combo.currency}
                  </span>
                </div>

                <ul className="space-y-3 mb-8 flex-1" data-id="element-108">
                  {combo.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-gray-700" data-id="element-109">
                      <Check className="w-4 h-4 text-[#6b9d3e] flex-shrink-0 mt-0.5" data-id="element-110" />
                      <span data-id="element-111">{feature}</span>
                    </li>)}
                </ul>

                <a href={combo.checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full" data-id="element-112">
                  <Button variant={combo.highlight ? 'primary' : 'outline'} fullWidth className={combo.highlight ? 'py-4 text-lg' : ''} data-id="element-113">
                    {combo.cta}
                  </Button>
                </a>
              </div>

              {/* Anti-doubt footer for first card only */}
              {i === 0 && <div className="bg-gray-50 p-4 text-xs text-gray-500 border-t border-gray-100" data-id="element-114">
                  <div className="flex items-center gap-2 mb-1" data-id="element-115">
                    <Check className="w-3 h-3 text-[#4a7c2c]" data-id="element-116" /> Resultados
                    desde el primer intento
                  </div>
                  <div className="flex items-center gap-2" data-id="element-117">
                    <Check className="w-3 h-3 text-[#4a7c2c]" data-id="element-118" /> Ideal para
                    principiantes
                  </div>
                </div>}
            </motion.div>)}
        </div>

        {/* Security & Guarantee */}
        <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-119">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-600 bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-120">
            <div className="flex items-center gap-2" data-id="element-121">
              <Lock className="w-4 h-4 text-[#4a7c2c]" data-id="element-122" />
              <span data-id="element-123">Pago 100% seguro procesado por:</span>
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/k9x8JCcUwfWxsaEMNBiB2R/Hotmart_logo.svg.png" alt="Hotmart" className="h-6 object-contain" data-id="element-124" />
          </div>

          <div className="bg-[#4a7c2c]/5 p-6 rounded-xl border border-[#4a7c2c]/10" data-id="element-125">
            <h4 className="font-bold text-[#2d5016] mb-2 flex items-center justify-center gap-2" data-id="element-126">
              <Shield className="w-5 h-5" data-id="element-127" />
              Garantía de 7 días
            </h4>
            <p className="text-gray-700" data-id="element-128">
              Si tienes algún inconveniente con el producto, tienes 7 días para
              solicitar tu reembolso completo.
            </p>
          </div>

          <p className="text-xs text-gray-400" data-id="element-129">
            💡 Importante: Puedes pagar con tarjeta de crédito, débito, PSE o
            efectivo a través de Hotmart, la plataforma líder en productos
            digitales.
          </p>
        </div>
      </div>
    </section>;
}